import type { FaireProductEntity } from "../../entity_types/product";

export const p_hu2ux7cnp8: FaireProductEntity = {
  token: "p_hu2ux7cnp8",
  type: "product",
  name: "First Aid Only 25-Person Home & Jobsite First Aid Kit",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/c60193158a6cd1d2b0a5ee9d6f6346dcad580a0e173991386fc6a33118da88ec.jpeg",
  galleryImageUrls: [],
  priceDollars: 40.59,
  description:
    "Prepare for unexpected emergencies with this comprehensive first aid kit, designed to address a wide variety of minor injuries. With 130 essential pieces, it ensures that you have the necessary tools to provide immediate care at home or on the jobsite. Compact and well-organized, this kit is perfect for treating up to 25 people, making it an indispensable addition to any household or workplace.\n",
  tags: [],
  msrpDollars: 81.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:25.225Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
